var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Flex } from "./..";
export var DialogFooter = function (props) { return (React.createElement(Flex, __assign({}, props, { lss: __assign({ width: 'auto', justifyContent: 'flex-end', alignItems: 'center', borderTop: 'regular', py: 'md', px: 'xl', flexShrink: 0 }, props.lss) }))); };
//# sourceMappingURL=DialogFooter.js.map